import { CombinedGraphQLErrors } from "@apollo/client/errors"

/**
 * The order-management backend returns structured validation errors under
 * `extensions.errorInfo.errors` (a string[]). Pull them out and join so the
 * user sees what actually failed, instead of a generic "Failed to save
 * workflow" alert.
 */
export const extractWorkflowErrorMessage = (
  error: Error | undefined
): string | null => {
  if (!error) return null

  if (CombinedGraphQLErrors.is(error)) {
    for (const gqlError of error.errors) {
      const errorInfo = (gqlError.extensions as { errorInfo?: unknown })
        ?.errorInfo
      const errors = (errorInfo as { errors?: unknown })?.errors
      if (Array.isArray(errors) && errors.length > 0) {
        return errors.filter((e) => typeof e === "string").join(" • ")
      }
      if (gqlError.message) return gqlError.message
    }
  }

  return error.message || null
}
